"use client";
// Client Component: triggers the Entra OAuth flow when enabled. Renders a
// Microsoft-branded button (4-square logo + standard label) so the SSO
// affordance is recognisable at a glance.
//
// When `disabled`, the click handler is suppressed and a small helper line
// below explains why — the button itself stays visible so users can see
// SSO is coming (ADR-031, dual-mode UX).

import { signIn } from "next-auth/react";
import { Button } from "@/components/ui/button";

function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={className}
    >
      <rect x="0" y="0" width="10" height="10" fill="#F25022" />
      <rect x="11" y="0" width="10" height="10" fill="#7FBA00" />
      <rect x="0" y="11" width="10" height="10" fill="#00A4EF" />
      <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
    </svg>
  );
}

export function EntraSignInButton({
  disabled = false,
  callbackUrl = "/",
}: {
  disabled?: boolean;
  /** Same-origin path to land on after signing in (see `safeCallbackPath`). */
  callbackUrl?: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <Button
        type="button"
        variant="outline"
        size="lg"
        className="border-surface-border-strong bg-surface-overlay text-text-primary hover:bg-surface-elevated h-11 w-full justify-center gap-3 text-sm font-medium"
        disabled={disabled}
        aria-disabled={disabled}
        onClick={
          disabled
            ? undefined
            : () => {
                void signIn("microsoft-entra-id", { callbackUrl });
              }
        }
      >
        <MicrosoftLogo className="size-[18px]" />
        Sign in with Microsoft
      </Button>
      {disabled ? (
        <p className="text-text-muted text-center text-xs">
          Single Sign-On is being configured by Kearney IT — coming soon.
        </p>
      ) : null}
    </div>
  );
}
